import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/vacaciones-tipos-de-nominas-empleados';

/**
 * GET Vacaciones Tipos Nominas Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getVacacionesTiposNominasEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Vacaciones Tipo Nomina Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getVacacionesTipoNominaEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Vacaciones Tipo Nomina Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postVacacionesTipoNominaEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Vacaciones Tipo Nomina Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchVacacionesTipoNominaEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Vacaciones Tipo Nomina Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteVacacionesTipoNominaEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
